import { useNavigation } from "o4a-react";
import * as React from "react";
import { ConsoleContext } from "../../console/ConsoleContext";
import { PageId, PageRegistrationConfig, SETTINGS_ROUTE } from "../../constants/pluginConstants";
import { OperationConfirmationProps } from "../OperationTypes";

export type OpenSettingsProps = Omit<OperationConfirmationProps, "location">;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OpenSettings = ({ onCancel }: OpenSettingsProps): JSX.Element => {
  const { navigateTo } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    navigateTo(
      `${SETTINGS_ROUTE}/${PageRegistrationConfig[PageId.SETTINGS][0].panelPath}`,
      PageRegistrationConfig[PageId.SETTINGS][0].key,
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newOpenSettings = (
  props: OpenSettingsProps,
): JSX.Element => (<OpenSettings {...props} />);
